import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {Giustificativi} from "@commons/mapping/Giustificativi";

export interface RiepilogoGiustificativi {
    giustificativo: GiustificativoRecord,
    quantita: number,
}

export class RiepilogoGiustificativi {
    giustificativo: GiustificativoRecord;
    quantita: number;

    constructor({giustificativo, quantita}: RiepilogoGiustificativi) {
        this.giustificativo = giustificativo;
        this.quantita = quantita;
    }

    static compareFn = (a: RiepilogoGiustificativi, b: RiepilogoGiustificativi): number => {
        return Giustificativi.compareFn(a.giustificativo, b.giustificativo);
    }
}